import styles from './InputItem.module.css'
import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";



export interface IRefInputItem {
    validate: () => boolean;
}


interface InputItemPreProcessInt
{
    (val:any):string
}
interface InputItemCbModeInt
{
    (val:any):void
}

interface InputItemPropsInt
{
    regExp?:RegExp
    val:string|boolean|number

    mode:string// ed
    onDelete?:InputItemCbModeInt
    onChange?:InputItemCbModeInt
    onKeyEnter?:InputItemCbModeInt
    onBlur?:InputItemCbModeInt
    onUpload?:InputItemCbModeInt
    onIncorrect?:InputItemCbModeInt
    onCorrect?:InputItemCbModeInt
    onPreProcess?:InputItemPreProcessInt
    placeHolder?:string
    minWidth?: string
    maxLen?:number
    onTitleDoubleClick?:()=>void
    hideEditIcon?:boolean

    cssInput?:string

    skipFlow?:boolean

    title?:string
    info?:string
    type?:string
    exitOnEnter?:boolean


    inputType?:number
    lineCount?:number

    titleShift?:number


}

const InputItem = forwardRef<IRefInputItem,InputItemPropsInt>(({onTitleDoubleClick,hideEditIcon,onKeyEnter, cssInput,info,lineCount,type,placeHolder,maxLen,minWidth,titleShift,onPreProcess,title,onUpload,onChange,onCorrect, onBlur, onIncorrect,regExp,inputType,mode,skipFlow,val,exitOnEnter}:InputItemPropsInt,ref, )=>{

    const [localVal, setLocalVal] = useState<any>(val)
    const [startVal, setStartVal] = useState(true)

    const [isEditable, setIsEditable] = useState(false)
    const [isCorrect, setIsCorrect] = useState(true)
    const [showHint, setShowHint] = useState(false)
    const lockSend = useRef(true)

    const [inputLocalType, setInputLocalType] = useState(inputType ? inputType : 0)


    const inputRef = useRef<HTMLInputElement >(null)


    useImperativeHandle(ref, () => ({
        validate : validate,
    }));


    useEffect(()=>{
        if(mode.match(/e/ui))setIsEditable(true)

        if(skipFlow)
        {
            if(! startVal) return;
            setLocalVal(val)
            setStartVal(false)
        }
        setLocalVal(val)
    },[val])

    useEffect(()=>{
        //if(showInput && inputRef?.current) inputRef.current.focus()
    },[isEditable])

    useEffect(()=>{
        lockSend.current = false
        if(regExp && onCorrect && localVal!==undefined)
        {
            const rg = regExp ? regExp : /.*/ui

            const vl = typeof localVal !=="string" ? localVal.toString() : localVal
            if(localVal?.match(rg)) onCorrect(localVal)
        }
        if(onChange && localVal !== undefined)onChange(localVal)

    },[localVal])


    const validate = ():boolean => {
        //console.log(localVal, regExp)
        if(localVal === undefined) return false
        if(regExp === undefined) return true
        if(localVal?.match(regExp)) return true
        return false
    }

    const buildModeList = () =>{
        const itm = mode?.split('')?.map((item,idx)=>{
            if(item.match(/e/ui) && !hideEditIcon) return(
                <div key={idx} className={[styles.modeItm].join(' ')}
                     onClick={()=>{
                         if(inputRef?.current) {
                             inputRef.current.focus()
                             inputRef.current.select()
                         }
                     }}
                ><i className={'bx bx-edit-alt'}></i></div>
            )
            if(item.match(/d/ui)) return <div key={idx} className={styles.modeItm}><i className='bx bx-message-alt-x'></i></div>
            if(item.match(/u/ui)) return <div key={idx} className={styles.modeItm}
                                              onClick={()=>{
                                                  if(isCorrect && onUpload) onUpload(localVal)
                                              }}
            ><i className='bx bx-upload'></i></div>
            if(item.match(/a/ui)) return <div key={idx} className={styles.modeItm}><i className='bx bxs-file-plus'></i></div>
            if(item.match(/i/ui)) return <div key={idx} className={styles.modeItm} onClick={()=>handleInfo()}><i className='bx bx-help-circle'></i></div>
            if(item?.match(/p/ui))return <a href={buildPhoneLink()}><i className='bx bxs-phone-call'></i></a>

        })
        return itm ? <div className={styles.modeCont}>{itm}</div> : null

    }


    const buildPhoneLink = ()=>{
        const x = typeof localVal === "string" ? localVal : localVal?.toString()
        const phoneRgx  = x?.replace(/[^0-9]/uig,'')?.match(/[0-9]{10}$/ui)
        if(phoneRgx) return `tel:+7${phoneRgx[0]}`
        return "#"

    }

    const handleInfo = () =>{
        setShowHint(true)
        setTimeout(()=>setShowHint(false),2000)
    }
    const buildTitle = () =>{
        if(title) return (
            <div className={[styles.itmTitle,"col-sm-4"].join(' ')}>{title}</div>
        )
        return null
    }

    const handleCloseCheckBox = (e: any) =>{
        if(localVal === undefined) return;
        if(onBlur && !lockSend.current)onBlur(localVal ? false: true)
    }


    const handleEnterInput = () =>{
        setIsCorrect(true)
    }

    const handleCloseInput = (e:any)=>{
        if(localVal === undefined) return;
        let vl = typeof localVal ==="string" ? localVal.trim() : localVal.toString().trim()
        if(onPreProcess) vl = onPreProcess(vl)


        if(regExp)
        {
            const rg = regExp ? regExp : /.*/ui
            if(!vl?.toString().match(rg))
            {
                setIsCorrect(false)
                if(onIncorrect)onIncorrect(vl)
                return
            }
        }
        //setShowInput(false)
        setIsCorrect(true)
        if(onBlur && !lockSend.current)onBlur(vl )
        setLocalVal(vl)
        lockSend.current = true
    }
    let dt =0
    if( titleShift ) dt = titleShift
    if( inputLocalType ===1 ) dt = 5+dt

    return(
        <div className={styles.itmCont} style={{minWidth: minWidth ? minWidth : "none"}}>
            <div className={[styles.itmValCont,"row"].join(' ')}>
                <div className={[styles.itmTitle,`col-sm-${4+dt}`, onTitleDoubleClick ? styles.cPointer : ""].join(' ')}
                    onDoubleClick={()=>{
                        if(onTitleDoubleClick){
                            onTitleDoubleClick()
                            handleEnterInput()
                        }
                    }}
                >{title}</div>
                <div className={[styles.valCont,`col-sm-${8-dt}`].join(' ')}>
                    <div className={[styles.valBlock].join(' ')}>
                        <div className={[styles.inpCont, inputLocalType === 1 ? styles.cursor : ""].join(' ')}>

                            { inputLocalType === 0 &&
                                <input className={["form-control form-control-sm",cssInput ? cssInput : ""].join(' ')} type={"text"} value={localVal} ref={inputRef}
                                       onChange={(e)=>setLocalVal(e.target?.value)}
                                       onBlur={(e)=>handleCloseInput(e)}
                                       placeholder={placeHolder}
                                       maxLength={maxLen ? maxLen : 10000}
                                       readOnly={!isEditable}
                                       inputMode={type ==="numeric" ? type : "text"}
                                       onFocus={handleEnterInput}

                                       onKeyDown={(e)=>{
                                           if(e.key?.match(/enter/ui) && exitOnEnter) {
                                               handleCloseInput(e)
                                               e.currentTarget.blur()
                                               if(onKeyEnter)onKeyEnter(localVal)
                                           }
                                       }}

                                />
                            }
                            { inputLocalType === 3 &&
                                <input className={["form-control form-control-sm",cssInput ? cssInput : ""].join(' ')} type={"password"} value={localVal} ref={inputRef}
                                       onChange={(e)=>setLocalVal(e.target?.value)}
                                       onBlur={(e)=>handleCloseInput(e)}
                                       placeholder={placeHolder}
                                       readOnly={!isEditable}
                                       onFocus={handleEnterInput}

                                    //onDoubleClick={()=>setShowInput(isEditable)}
                                       inputMode={type ==="numeric" ? type : "text"}


                                       onKeyDown={(e)=>{
                                           if(e.key?.match(/enter/ui) && exitOnEnter) {
                                               handleCloseInput(e)
                                               e.currentTarget.blur()
                                           }
                                       }}

                                />
                            }
                            { inputLocalType === 1 &&
                                <input className={["form-check-input",styles.cursor, cssInput ? cssInput : ""].join(' ')} type={"checkbox"} checked={localVal} ref={inputRef}
                                       onChange={(e)=>
                                       {
                                           setLocalVal(localVal ? false : true)
                                           handleCloseCheckBox(e)
                                       }}
                                       disabled={!isEditable}
                                />
                            }
                            { inputLocalType === 2 &&
                                <textarea className={["form-control form-control-sm",cssInput ? cssInput : ""].join(' ')}  value={localVal}
                                          onChange={(e)=>setLocalVal(e.target?.value)}
                                          onBlur={(e)=>handleCloseInput(e)}
                                          readOnly={!isEditable}
                                          onFocus={handleEnterInput}
                                          rows={lineCount ? lineCount: 3 }
                                    //onDoubleClick={()=>setShowInput(isEditable)}
                                          inputMode={type ==="numeric" ? type : "text"}
                                          placeholder={placeHolder}

                                          onKeyDown={(e)=>{
                                              if(e.key?.match(/enter/ui) && exitOnEnter) {
                                                  handleCloseInput(e)
                                                  e.currentTarget.blur()
                                              }
                                          }}

                                />
                            }



                        </div>
                        {  buildModeList()}

                    </div>
                    {showHint && <div className={styles.hint}>{info}</div>}
                    {!isCorrect && <div className={styles.valInc}>Не корректное значение</div>}
                </div>
            </div>
        </div>
    )



})

export default InputItem